import i18next from "i18next";
import styled from "styled-components";

interface LoadingIconProps {
  style?: React.CSSProperties;
  className?: string;
  loadingText?: string;
}

const LoadingWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  img {
    width: 40px;
    height: 40px;
    animation: spin 1s infinite linear;
    margin-bottom: 14px;
  }
  .loading-text {
    color: rgba(194, 196, 204, 1);
    font-size: 14px;
  }
`;

const LoadingIcon: React.FC<LoadingIconProps> = ({ className, loadingText = `${i18next.t("common.loading")}` }) => {
  return (
    <LoadingWrapper className={className}>
      <img src="https://st.joy-sourcing.com/website/other/loading.png" />
      <p className="loading-text">{loadingText}</p>
    </LoadingWrapper>
  );
};

export default LoadingIcon;
